import React,{useState} from 'react'

export default function Text(props) {
    const[text,setText]=useState("");
    const handleUpClick=()=>{
        let newText=text.toUpperCase();
        setText(newText)
        props.showAlert("Your Text Cconverted to UpperCase !","success");
    }
    const handleLowClick=()=>{
        let newText=text.toLowerCase();
        setText(newText);
        props.showAlert("Your Text Cconverted to LowerCase !","success");
    }

    const speak= () => {
        let msg = new SpeechSynthesisUtterance(text);
        window.speechSynthesis.speak(msg);
        const toggle = document.getElementById('toggle')
        if (toggle.textContent === "Speak") {
            toggle.innerHTML = "Stop"
        }
        else {
            toggle.innerHTML = "Speak"
            if (toggle.innerHTML === "Speak"){
                window.speechSynthesis.cancel()
                toggle.innerHTML="Speak";
            }
        }
    }
    const handleCopy=()=>{
        navigator.clipboard.writeText(text);
        props.showAlert("Your Text is Copied to Clipboard !","success");
    }
    const handleExtraSpaces=()=>{
        let newText=text.split(/[ ]+/);
        setText(newText.join(" "));
        props.showAlert("Extra Spaces Removed !","success");
    }

       const handleCapitalize = () => {
        let newText = text
            .toLowerCase()
            .replace(/(^\s*[a-z])|([.!?]\s*[a-z])/g, function (match) {
                return match.toUpperCase();
            });

        setText(newText);
        props.showAlert("Text Capitalized Successfully!", "success");
    };

        const handleClearClick=()=>{
        let newText='';
        setText(newText)
        const toggle = document.getElementById('toggle');
        if (toggle) toggle.innerHTML = "Speak" 
        window.speechSynthesis.cancel();
    }
    const handleOnChange =(event)=>{
        // console.log("OnChange");
        setText(event.target.value);
    }   
     return (
        <>
        <div className='container my-3' style={{color:props.mode==='light'?'black':'white'}}>
            <h1>{props.heading}</h1>
            <div className="mb-3">
                <textarea className="form-control" value={text} onChange={handleOnChange} style={{backgroundColor:props.mode==='light'?'white':'#2a2f33',color:props.mode==='light'?'black':'white'}}  id="box" rows="10"></textarea>
            </div>
            <button className="btn btn-primary mx-2 my-1" disabled={text.length===0}  onClick={handleUpClick}>Convert to UpperCase</button>
            <button className="btn btn-primary mx-2 my-1" disabled={text.length===0} onClick={handleLowClick}>Convert to LowerCase</button>
            <button className="btn btn-primary mx-2 my-1" disabled={text.length===0} onClick={handleCopy}>Copy</button>
            <button className="btn btn-primary mx-2 my-1" disabled={text.length===0} onClick={handleExtraSpaces}>Remove Extra Spaces</button>
            <button className="btn btn-primary mx-2 my-1" disabled={text.length === 0} onClick={handleCapitalize}>Capitalize</button>
            <button type="submit" disabled={text.length===0} className="btn btn-warning mx-2 my-2" onClick={speak}  id="toggle">Speak</button>
            <button className="btn btn-success mx-3 my-1" disabled={text.length===0} onClick={handleClearClick}>Clear</button>
        </div>
        <div className="container" style={{color:props.mode==='light'?'black':'white'}}> 
            <h2>Your Text Summary</h2>
            <h6>• Words and Characters count :</h6>
            <p>{text.split(/\s+/).filter((element)=>{return element.length!==0}).length} WORDS and {text.length} CHARACTERS</p>
            <h6>• Reading Speed :</h6>
            <p>{0.008*text.split(" ").filter((element)=>{return element.length!==0}).length} Minutes to read</p>
            <h3>Preview</h3>
            <p>{text.length>0?text:"Nothing to Preview !"}</p>
        </div>
        </>
    )
}
